<template>
    <div class="home-hero" v-if="banners.length && isActive">
        <carousel v-bind="options">
            <slide v-for="(item, index) in banners" :key="index" @slideclick="handleSlideClick"
                :aria-label="item.caption || item.title">
                

                    <hero-media :item="item" :thumbnail="thumbnail" />
<!--                     
                    <a class="hero-stage" v-if="item.externalLink" target="_blank" :href="item.externalLink">
                        
                    </a>
                    <a v-else-if="item.uri" class="hero-stage" :href="item.uri">
                        <hero-media :item="item" :thumbnail="thumbnail" />
                    </a>
                    <div class="hero-stage" v-else>
                        <hero-media :item="item" :thumbnail="thumbnail" />
                    </div> -->

                    <!-- <div class="hero-content" v-if="item.title">
                        <h2 class="hero-content-title" v-html="item.title"></h2>
                        <p class="hero-content-detail" v-if="item.description" v-html="item.description"></p>

                        <div class="hero-content-buttons" v-if="item.button_text">
                            <a v-if="item.externalLink" :href="item.externalLink" target="_blank"
                                class="btn btn-primary btn-icon-wrap btn-shadow">
                                <span class="btn-icon material-symbols-outlined">north_east</span>
                                <span class="btn-text">{{ item.button_text }}</span>
                            </a>
                            <a v-else :href="item.uri" class="btn btn-primary btn-icon-wrap btn-shadow">
                                <span class="btn-icon material-symbols-outlined">north_east</span>
                                <span class="btn-text">{{ item.button_text }}</span>
                            </a>
                        </div>
                    </div> -->

                   
                <!-- </div> -->
            </slide>
        </carousel>
    </div>
    <div v-else class="home-hero-thumbnail"></div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import HeroMedia from './HeroMedia';

export default {
    props: ['banners', 'thumbnail'],
    components: {
        Carousel,
        Slide,
        HeroMedia,
    },
    data() {
        return {
            isActive: true,
            options: {
                perPage: 1,
                mouseDrag: true,
                autoplay: true,
                loop: true,

                navigationEnabled: true,
                navigationNextLabel: `<svg viewBox="0 0 24 24" focusable="false"><g><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></g></svg>`,
                navigationPrevLabel: `<svg viewBox="0 0 24 24" focusable="false"><g><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></g></svg>`,

                autoplayTimeout: 5000
            }
        }
    },

    created() {
        this.options.mouseDrag = this.banners.length > 1
    },

    mounted() {
        // console.log(this.banners);
    },

    computed: {
        isVideoPlaying() {
            return this.banners.some(item => item.videoUrl);
        }
    },

    methods: {
        onSlideChange() {
            // console.log('slide change');
        },

        handleSlideClick() {
            // console.log('slide Click');
        }
    }
}
</script>

<style lang="scss" scoped>
.home-hero {
    position: relative;
    background-color: #f2f2f2;
}

.hero-slide {
    position: relative;
    overflow: hidden;

    padding-bottom: 0;
    height: 80vh;
}

.hero-content {
    position: absolute;
    left: 50%;
    max-width: 400px;
    height: 100%;
    width: 100%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 15px;
    align-items: center;
    background-color: rgba(0, 0, 0, .8);
    color: #fff;
    padding: 24px;
    text-align: center;
    z-index: 100;

    // position: absolute;
    // left: 0;
    // max-width: 400px;
    // height: 100%;
    // width: 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // gap: 15px;
    // color: #fff;
    // padding: 24px;
    // text-align: left;
    // z-index: 100;
    // background: linear-gradient(to right, #000 0, #000 30%, transparent 100%);
}

.hero-content-title {
    font-size: 22px;
    font-weight: 700;

    margin-bottom: 0;
}

.hero-content-detail {
    font-size: 15px;
    font-weight: 400;

    margin-bottom: 0;
}

.hero-stage {
    position: absolute;
    inset: 0;

    img,
    video {
        position: absolute;
        inset: 0;

        object-fit: cover;
        width: 100%;
        height: 100%;
    }


}


@media (min-width: 400px) {
    .hero-slide {
        height: 0;
        padding-bottom: 80%;
    }
}

@media (min-width: 768px) {
    .hero-slide {
        padding-bottom: 50%;
    }

    .hero-content-title {
        font-size: 28px;
    }

    .hero-content-detail {
        font-size: 18px;
    }
}

@media (min-width: 1024px) {
    .hero-slide {
        padding-bottom: 36.7857%;
    }

    .hero-content {
        max-width: 680px;
        padding-left: 40px;
        padding-right: 40px;
    }

    .hero-content-title {
        font-size: 32px;
    }

    .hero-content-detail {
        font-size: 20px;
    }
}
</style>